import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";

import Dashboard from "@/pages/Dashboard.vue";
import ServiceProviders from "@/pages/ServiceProviders.vue";
import ServiceProvidersReal from "@/pages/ServiceProvidersReal.vue";

import SubAdmins from "@/pages/SubAdmins.vue";
import Login from "@/pages/Login.vue";
import Users from "@/pages/Users.vue";

const routes = [
  {
    path: "/",
    name: "Login",
    component: Login,
  },
  {
    path: "/admin",
    component: DashboardLayout,
    redirect: "/admin/dashboard",
    children: [
      {
        path: "dashboard",
        name: "Dashboard",
        component: Dashboard,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "sub-admins",
        name: "SubAdmins",
        component: SubAdmins,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "providers",
        name: "providers",
        component: ServiceProvidersReal,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "service-providers",
        name: "Service Providers",
        component: ServiceProviders,
        meta: {
          requiresAuth: true,
        },
      },
      {
        path: "users",
        name: "Users",
        component: Users,
        meta: {
          requiresAuth: true,
        },
      },
    ],
  },
];

export default routes;
